import React from "react";

export const ParticlesCanvas = () => {
  return (
    <canvas className="background" style={{ position: "absolute" }}/>
  )
}

export default ParticlesCanvas